import { trackingEndpointLogic } from "./tracking";

/**
 *
 *
 */
declare global {
  interface Navigator {
    /**
 *
 */
    connection?: {
      /**
 *
 */
      effectiveType?: string;
    };
  }
}

/**
 *
 *
 *
 *
 *
 */
export const trackConnectionType = (
  rum_effectiveType = navigator.connection?.effectiveType,
) => {
  if (rum_effectiveType !== undefined) {
    trackingEndpointLogic({ rum_effectiveType });
  }
};
